const GridFunctions = {
  onSelectionChanged: (_ref, _saveFunc) => {
    const selected = _ref.current.api.getSelectedRows();
    _saveFunc(selected);
  },

  onCellValueChanged: (_row, _ref, _saveFunc) => {
    let changeRow = _ref.current.api.getDisplayedRowAtIndex(_row.rowIndex);
    if (_row.oldValue !== _row.newValue) {
      _saveFunc((current) => [
        ...current,
        {
          ..._row.data,
          newYn: "Y",
          rowIdx: _row.rowIndex,
        },
      ]);
      _ref.current.api.flashCells({
        rowNodes: [changeRow],
      });
      changeRow.setData({ ...changeRow.data, newYn: "Y" });
    }
  },

  getRowStyle: (_row) => {
    if (_row.data.newYn === "Y") {
      return { background: "#d0f4f9" };
    }
  },
};

export default GridFunctions;
